import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_BASE_URL } from '../constants/api'

const typeformRepository = createApi({
	reducerPath: 'typeformRepository',
	baseQuery: fetchBaseQuery({
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['Typeform'],
	endpoints: (builder) => ({
		getResult: builder.mutation<
			{
				landing_id: string
				token: string
				response_id: string
				response_type: string
				landed_at: string
				submitted_at: string
				metadata: {
					user_agent: string
					platform: string
					referer: string
					network_id: string
					browser: string
				}
				hidden: object
				calculated: {
					score: number
				}
				answers: Array<{
					field: {
						id: string
						type: string
						ref: string
					}
					type: string
					text?: string
					email?: string
					boolean?: boolean
					choice?: {
						id: string
						ref: string
						label: string
					}
					number?: number
				}>
				variables: Array<{
					key: string
					type: string
					number?: number
					outcome_id?: string
				}>
				outcome: {
					id: string
					ref: string
					title: string
				}
			},
			{
				formId: string
				responseId: string
			}
		>({
			query: ({ formId, responseId }) => ({
				url: `/v1/user/proficiency?formId=${formId}&responseId=${responseId}`,
				method: 'GET',
			}),
			invalidatesTags: ['Typeform'],
		}),
	}),
})

export default typeformRepository
